export default __webpack_public_path__ + "assets/burkina-faso-flag.png";